import { AlertTriangle, ArrowLeft } from "lucide-react";
import { Link, useSearchParams } from "react-router-dom";
import CloudEntityAnalytics from "./CloudEntityAnalytics";
import { Card, CardContent } from "../../ui/card";
import { Button } from "../../ui/button";
import { readDashboardAnalyticsQuickLink } from "../CloudDashboard/lib/cloudEntityQuickLinks";

export default function CloudEntityAnalyticsBridge() {
  const [searchParams] = useSearchParams();
  const linkId = searchParams.get("linkId") || "";
  const payload = readDashboardAnalyticsQuickLink(linkId);

  if (!payload) {
    return (
      <div className="flex min-h-[70vh] items-center justify-center p-6">
        <Card className="w-full max-w-xl border-border/60 shadow-sm">
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
              <AlertTriangle className="h-6 w-6 text-primary" />
            </div>
            <div className="space-y-2">
              <h1 className="text-xl font-semibold text-foreground">
                Analytics link expired
              </h1>
              <p className="text-sm text-muted-foreground">
                This quick link is no longer available. Please reopen the entity
                from the NHI Dashboard and try again.
              </p>
            </div>
            <Button asChild variant="outline" className="gap-2">
              <Link to="/dashboard/cloud-dashboard">
                <ArrowLeft className="h-4 w-4" />
                Back to NHI Dashboard
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <CloudEntityAnalytics {...payload} />;
}
